/*!
 * devextreme-react
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatesStore = void 0;
var TemplatesStore = /** @class */ (function () {
    function TemplatesStore(onTemplateAdded) {
        this._templates = {};
        this._onTemplateAdded = onTemplateAdded;
    }
    TemplatesStore.prototype.add = function (templateId, templateFunc) {
        this._templates[templateId] = { template: templateFunc, isDeferredRemove: false };
        this._onTemplateAdded();
    };
    TemplatesStore.prototype.setDeferredRemove = function (templateId, isDeferredRemove) {
        if (this._templates[templateId]) {
            this._templates[templateId].isDeferredRemove = isDeferredRemove;
        }
    };
    TemplatesStore.prototype.removeDefferedTemplate = function () {
        var _this = this;
        Object.entries(this._templates)
            .filter(function (_a) {
            var templateInfo = _a[1];
            return (templateInfo.isDeferredRemove);
        })
            .forEach(function (_a) {
            var templateId = _a[0];
            delete _this._templates[templateId];
        });
    };
    TemplatesStore.prototype.renderWrappers = function () {
        var _this = this;
        this.removeDefferedTemplate();
        return Object.getOwnPropertyNames(this._templates).map(function (templateId) { return _this._templates[templateId].template(); });
    };
    return TemplatesStore;
}());
exports.TemplatesStore = TemplatesStore;
